import { useContext } from "react";
import { APIStatusContext} from "../../../providers/apiStatusProvider";

export default function APIStatusDisplay( { className } ) {
    const { isLoading } = useContext(APIStatusContext);

    if (isLoading) {
        return (
            <div className={`absolute content-end h-screen w-screen z-[150] ${className}`}>
                <div className="absolute inset-x-4 top-[50%] w-[256px] h-[256px] -translate-y-[50%] left-[50%] 2xl:left-[50%] -translate-x-[50%]">
					<img src="/images/spinner.gif" />
                </div>
            </div>
        )
    }
}